export default {

  methods: {

    scrollToElement(element, adjustment, duration = 360) {
      let $element = $(element);
      let heightAdjust = adjustment === null ? 0 : adjustment

      if ($element?.length) {
        let $element = $(element);
        let offset = $element.position().top - heightAdjust;

        this.scrollToPosition(offset, duration);
      }
    },

    scrollToBottomOfElement(element, duration = 360) {

      let $element = $(element);

      if ($element?.length) {
        let offset = $element.position().top;
        let height = $element.outerHeight();

        this.scrollToPosition(offset + height, duration);
      }
    },

    scrollToCenter(element, duration = 360) {
      let $element = $(element);

      if ($element?.length) {
        let elementOffset = $element.offset().top;
        let elementHeight = $element.height();
        let windowHeight = $(window).height();
        let offset = elementOffset - (windowHeight / 2) + (elementHeight / 2);

        this.scrollToPosition(offset, duration);
      }
    },

    scrollToPosition(position, duration = 360) {

      let startingY = window.pageYOffset;
      let scrollDiff = position - startingY;
      let start;

      window.requestAnimationFrame(function step(timestamp) {

        if(!start) start = timestamp;
        let time = timestamp - start;

        let percent = Math.min(time / duration, 1) || 1;

        window.scrollTo(0, startingY + scrollDiff * percent);

        if(time < duration) {
          window.requestAnimationFrame(step);
        }

      });

    }

  }

}
